import { createSlice } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';

import { AI_SEARCH_SLICE_NAME } from '../slicesNames';
import { aiSearch } from './aiSearchThunks';
import { API_CONTENT_ERROR_MESSAGE, CHAT_CONTENT_ERROR_MESSAGE } from '../chat/chatConstants';
import * as appActions from '../../appActions';

const getInitialState = () => ({
  aiSearchKey: uuidv4(),

  searchInputValue: '',
  searchPrompt: '',
  loading: false,
  error: null,
  response: {
    chatResponse: '',
    recommendations: {
      specialties: [],
    },
  },

  quickFeedback: {
    shouldPrompt: false, // trigger timeout to display form
    shouldDisplay: false, // show or hide form
    progress: 0,
  },
});

const aiSearchSlice = createSlice({
  name: AI_SEARCH_SLICE_NAME,
  initialState: getInitialState(),
  reducers: {
    reset: () => getInitialState(),
    setInput: (state, action) => {
      state.searchInputValue = action.payload;
    },
    setShouldPromptFeedback: (state, action) => {
      state.quickFeedback.shouldPrompt = action.payload;
    },
    setShouldDisplayFeedback: (state, action) => {
      state.quickFeedback.shouldDisplay = action.payload;
    },
    setQuickFeedbackProgress: (state, action) => {
      state.quickFeedback.progress = action.payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(aiSearch.pending, (state) => ({
      // reset all values except search inputs and loading
      ...getInitialState(),
      loading: true,
      searchInputValue: state.searchInputValue,
      searchPrompt: state.searchInputValue,
    }));
    builder.addCase(aiSearch.fulfilled, (state, action) => {
      state.loading = false;
      state.response = action.payload;
      state.quickFeedback.shouldPrompt = true;
    });
    builder.addCase(aiSearch.rejected, (state, action) => {
      const { error = {} } = action;
      let message;

      if (error.data?.user_message) message = error.data.user_message;
      else if (error.data?.detail === API_CONTENT_ERROR_MESSAGE)
        message = CHAT_CONTENT_ERROR_MESSAGE;
      else message = 'There was an error. Please try again.';

      state.loading = false;
      state.error = message;
      state.quickFeedback.shouldPrompt = true;
    });
    builder.addCase(appActions.startOver, () => getInitialState());
  },
});

export default aiSearchSlice;
export const {
  reset,
  setInput,
  setShouldPromptFeedback,
  setShouldDisplayFeedback,
  setQuickFeedbackProgress,
} = aiSearchSlice.actions;
